import Header from "../components/Header";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar"
import MobileDashboardMenus from "../components/MobileDashboardMenus";

export default function AppLayout() {
  return (
    <div>
      <Header />
      <main className="grid grid-cols-1 md:grid-cols-12 min-h-screen py-6 gap-4">
        <MobileDashboardMenus />
        <Sidebar />
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
